import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export type LibraryPreviewItem = {
  title: string;
  description: string;
  previewImage?: string | null;
  index?: string[] | null;
};
type Props = {
  item: LibraryPreviewItem | null;
  onClose: () => void;
};
export function LibraryPreviewSheet({
  item,
  onClose
}: Props) {
  return <AnimatePresence data-id="element-371" data-mp="2j3i3eszh9v0z">
      {item && <>
          <motion.div key="backdrop" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-[2px]" aria-hidden="true" data-id="element-372" data-mp="3gpxmfz7jz0qn" />

          <motion.div key={`sheet-${item.title}`} role="dialog" aria-modal="true" aria-label={item.title} initial={{
        y: '100%',
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: '100%',
        opacity: 0
      }} transition={{
        type: 'spring',
        damping: 32,
        stiffness: 320
      }} className="fixed inset-x-0 bottom-0 z-[61] mx-auto max-h-[86vh] w-full max-w-[480px] overflow-y-auto rounded-t-[20px] border border-[#c9a96e]/25 bg-[#141210] px-5 pb-8 pt-4 md:inset-x-auto md:left-1/2 md:top-1/2 md:bottom-auto md:max-h-[80vh] md:w-[420px] md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-[20px]" data-id="element-373" data-mp="3211gc7p23xso">
            <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-[#c9a96e]/25 md:hidden" data-id="element-374" data-mp="3o9y4kw4gpeb7" />

            <button type="button" onClick={onClose} aria-label="Cerrar preview" className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full border border-[#c9a96e]/25 text-[#c9a96e]" data-id="element-375" data-mp="3ocavhys76z0e">
              ×
            </button>

            {/* data-testid expone qué recurso está montado, para poder verificarlo por fuera de la UI (inspector / QA) y no solo a simple vista. */}
            <div data-testid="library-preview-title" data-resource={item.title} data-id="element-376" data-mp="1dg29onjt4oab">
              <h3 className="font-display text-[22px] leading-tight text-[#E8D5B0] pr-8" data-id="element-377" data-mp="1iex5cq2vi7bu">
                {item.title}
              </h3>
            </div>

            {item.index && item.index.length > 0 && <ul className="mt-4 space-y-2 border-t border-[#c9a96e]/12 pt-4" data-id="element-378" data-mp="1bzg92fahuy0x">
                {item.index.map((line, i) => <li key={i} className="font-body text-[14px] leading-snug text-[#F0E8D8]/80" data-id="element-379" data-mp="173r5m0vcswzc" data-mpi={i}>
                    {line}
                  </li>)}
              </ul>}

            <p className="mt-4 font-body text-[14px] leading-relaxed text-[#F0E8D8]/70" data-id="element-380" data-mp="1zp0rmx2qjt9o">
              {item.description}
            </p>

            {item.previewImage ? <div data-testid="library-preview-image" data-resource={item.title} className="mt-5 overflow-hidden rounded-[10px] border border-[#c9a96e]/15 bg-[#090807]" data-id="element-381" data-mp="1q09554gg2165">
                <img src={item.previewImage} alt={`Vista previa de ${item.title}`} loading="lazy" decoding="async" className="block h-auto w-full" data-id="element-382" data-mp="1kzbjghw86ozw" />
              </div> :
        // Estado explícito cuando no hay asset real: nunca se reutiliza la imagen de otra card.
        <div data-testid="library-preview-placeholder" data-resource={item.title} className="mt-5 flex flex-col items-center justify-center gap-2 rounded-[10px] border border-dashed border-[#c9a96e]/25 bg-[#0c0a08] px-4 py-10 text-center" data-id="element-383" data-mp="2l2jg5lxiz2f1">
                <span className="font-display text-[15px] text-[#c9a96e]" data-id="element-384" data-mp="2v1s3hvxvxisf">{item.title}</span>
                <span className="font-body text-[12px] uppercase tracking-[0.14em] text-[#F0E8D8]/40" data-id="element-385" data-mp="2zw5ulm5il3ra">
                  Preview próximamente
                </span>
              </div>}

            <button type="button" onClick={onClose} className="mt-6 w-full rounded-[8px] border border-[#c9a96e]/30 py-3 text-center font-body text-[12px] uppercase tracking-[0.14em] text-[#c9a96e]" data-id="element-386" data-mp="38xdug8noicnh">
              Cerrar preview
            </button>
          </motion.div>
        </>}
    </AnimatePresence>;
}